<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="warehouse"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1">
            Magacin info
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-list>
                <v-list-item>
                  <v-list-item-content class="mb-0 pb-0">
                    <v-text-field
                      v-model="item.wh_code"
                      outlined
                      label="Šifra magacina"
                      maxlength="50"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                    <v-text-field
                      v-model="item.name"
                      outlined
                      label="Naziv magacina"
                      maxlength="100"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                    <v-text-field
                      v-model="item.address"
                      outlined
                      label="Adresa"
                      maxlength="256"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                    <v-text-field
                      v-model="item.zip"
                      outlined
                      label="Poštanski broj"
                      maxlength="10"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                    <v-text-field
                      v-model="item.city"
                      outlined
                      label="Grad"
                      maxlength="100"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-0 pb-0">
                    <v-text-field
                      v-model="item.country"
                      outlined
                      label="Država"
                      maxlength="100"
                      counter
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-0 pt-1 mb-6 pb-0">
                    <webpage_lookup_work_order_worker
                      update="wp_worker_changed"
                      :selected_id="item.employee_id"
                      :selected_name="item.employee_name"
                    ></webpage_lookup_work_order_worker>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content class="mt-1 pt-1 mb-0 pb-0">
                    <v-textarea
                      v-model="item.notes"
                      outlined
                      auto-grow
                      clearable
                      label="Specijalne napomene"
                      maxlength="256"
                      counter
                    ></v-textarea>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="mt-0 pt-0 mb-4">
                  <v-switch
                    style="margin-top: -2.5rem;"
                    hide-details
                    v-model="item.active"
                    label="Magacin aktivan"
                  ></v-switch>
                </v-list-item>
              </v-list>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="is_btn_loading" text @click="save_item()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_work_order_worker: () =>
      import("@/components/lookups/work_order_worker"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    is_loading: true,
    is_btn_loading: false,
    item: {
      id: 0,
      wh_code: null,
      name: null,
      address: null,
      zip: null,
      city: null,
      country: null,
      employee_id: null,
      employee_name: null,
      notes: null,
      active: 1,
    },
    title: "Magacin info",
    visible: false,
  }),
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
        } else {
          this.item = {
            id: 0,
            wh_code: null,
            name: null,
            address: null,
            zip: null,
            city: null,
            country: null,
            employee_id: null,
            employee_name: null,
            notes: null,
            active: 1,
          };
          this.is_loading = false;
        }
      },
      immediate: false,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.item.wh_code == null || this.item.wh_code.length == 0) {
          has_errors = true;
          reject("Šifra magacina polje je obavezno");
        }
        if (this.item.address == null || this.item.address.length == 0) {
          has_errors = true;
          reject("Adresa polje je obavezno");
        }
        if (this.item.zip == null || this.item.zip.length == 0) {
          has_errors = true;
          reject("Poštanski broj polje je obavezno.");
        }
        if (this.item.city == null || this.item.city.length == 0) {
          has_errors = true;
          reject("Grad polje je obavezno.");
        }
        if (this.item.country == null || this.item.country.length == 0) {
          has_errors = true;
          reject("Država polje je obavezno.");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    get_item() {
      this.is_loading = true;
      this.$http({
        method: "POST",
        url: "/warehouses/get_warehouse_by_id",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      })
        .then((resp) => {
          this.item = resp.data.result;
          this.is_loading = false;
        })
        .catch((e) => {
          alert(e);
        });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_worker_changed", (selected_item) => {
        if (selected_item !== null) {
          this.item.employee_id = selected_item.id;
          this.item.employee_name = selected_item.name;
        } else {
          this.item.employee_id = null;
          this.item.employee_name = null;
        }
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_worker_changed");
    },
    close_dialog() {
      this.$webpageEventBus.$emit("close_warehouse");
    },
    save_item() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.item.account_id = this.$store.getters.user.account_id;
          this.$http({
            method: "POST",
            url: "/warehouse/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Magacin info je ažuriran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_warehouse");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>

<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}
</style>
